import { LightningIcon } from '@braskai/icons';
import { Button, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

type UpgradeAlertProps = {
  buttonText?: string;
  text: string;
  onClick: () => void;
};

export const UpgradeAlert = ({ buttonText = 'Upgrade', text, onClick }: UpgradeAlertProps) => (
  <Stack
    sx={(theme) => ({
      backgroundColor: theme.palette.primary[50],
      color: theme.palette.primary[700],
    })}
    alignItems="center"
    borderRadius={8}
    direction="row"
    gap={2}
    justifyContent="space-between"
    padding="10px 16px"
  >
    <Typography color="primary.700" variant="body-2">
      {text}
    </Typography>
    <Button
      size="sm"
      startIcon={<LightningIcon height={20} width={20} />}
      sx={{ '.MuiButton-startIcon': { marginRight: 4 } }}
      variant="link"
      noPadding
      onClick={onClick}
    >
      {buttonText}
    </Button>
  </Stack>
);
